import React, { forwardRef } from 'react';
import { MenuItem, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useRailsClick, { RailsOperation } from '~/_base/hooks/useRailsClick';

interface RailsMenuItemProps {
  item: RailsOperation;
  onItemClick: () => void;
  onSuccess?: (message?: string) => void;
  onError?: (error: string) => void;
}

// See useRailsClick.tsx
const RailsMenuItem = forwardRef<HTMLLIElement, RailsMenuItemProps>(
  (props, ref) => {
    const classes = useStyles();
    const { divider, ...operation } = props.item;
    const onClickProps = useRailsClick(
      operation,
      props.onItemClick,
      props.onSuccess,
      props.onError
    );

    if (props.item.divider) {
      return <Divider />;
    } else {
      const itemName = props.item.name.replace('(beta)', '').trim();
      const isBeta = props.item.name.length !== itemName.length;
      return (
        <MenuItem
          data-testid={`rails-menu-item-${props.item.name}`}
          ref={ref}
          {...onClickProps}
          className={classes.root}
        >
          <span className="ape-label">
            {itemName}
            {isBeta && <span className="beta">beta</span>}
          </span>
        </MenuItem>
      );
    }
  }
);

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 3),
  },
}));

export default RailsMenuItem;
